import * as i from 'icepick'
import { IVoiceBunnySample, IVoice } from './types'
import { keyBy } from 'lodash'
import analytics from 'features/Analytics/Analytics.utils'

export interface IVoicesState {
  samples: {
    [cacheKey: string]: {
      loading: boolean
      results: IVoiceBunnySample[]
    }
  }
  byId: {
    [voiceId: string]: {
      data: IVoice
      loading: boolean
    }
  }
  list: {
    [cacheKey: string]: {
      loading: boolean
      error?: any
      data?: {
        results: string[]
        totalPages: number
        totalResults: number
        page: number
        limit: number
      }
    }
  }
  quote: { price?: number }
  quoteLoading: boolean
}

const initialState: IVoicesState = {
  byId: {},
  list: {},
  samples: {},
  quote: {},
  quoteLoading: false,
}

export const voicesReducer = (state: IVoicesState = initialState, action): IVoicesState => {
  switch (action.type) {
    case 'VOICE/GET_SAMPLES_PENDING':
      return i.assocIn(state, ['samples', action.meta.cacheKey, 'loading'], true)
    case 'VOICE/GET_SAMPLES_REJECTED':
      return i.assocIn(state, ['samples', action.meta.cacheKey, 'loading'], false)
    case 'VOICE/GET_SAMPLES_FULFILLED':
      return i
        .chain(state)
        .assocIn(['samples', action.meta.cacheKey, 'loading'], false)
        .assocIn(['samples', action.meta.cacheKey, 'results'], action.payload.data)
        .value()

    case 'VOICE/GET_QUOTE_PENDING':
      return i.assocIn(state, ['quoteLoading'], true)
    case 'VOICE/GET_QUOTE_REJECTED':
      return i.assocIn(state, ['quoteLoading'], false)
    case 'VOICE/GET_QUOTE_FULFILLED':
      return i
        .chain(state)
        .assocIn(['quoteLoading'], false)
        .assocIn(['quote'], action.payload.data)
        .value()

    case 'VOICE/GET_VOICE_PROJECT_PENDING':
      return i.assocIn(state, ['byId', action.meta.cacheKey, 'loading'], true)
    case 'VOICE/GET_VOICE_PROJECT_REJECTED':
      return i
        .chain(state)
        .assocIn(['byId', action.meta.cacheKey, 'loading'], false)
        .assocIn(['byId', action.meta.cacheKey, 'error'], action.payload.data)
        .value()
    case 'VOICE/GET_VOICE_PROJECT_FULFILLED':
      return i
        .chain(state)
        .assocIn(['byId', action.meta.cacheKey, 'loading'], false)
        .assocIn(['byId', action.meta.cacheKey, 'data'], action.payload.data)
        .value()

    case 'VOICE/GET_VOICE_PROJECTS_PENDING':
      return i.assocIn(state, ['list', action.meta.cacheKey, 'loading'], true)
    case 'VOICE/GET_VOICE_PROJECTS_REJECTED':
      return i.assocIn(state, ['list', action.meta.cacheKey], {
        error: action.payload.data,
        loading: false,
      })
    case 'VOICE/GET_VOICE_PROJECTS_FULFILLED':
      return i
        .chain(state)
        .assocIn(['list', action.meta.cacheKey, 'data'], {
          ...action.payload.data,
          results: action.payload.data.results.map(voice => voice.id),
        })
        .assocIn(['list', action.meta.cacheKey, 'loading'], false)
        .updateIn(['byId'], voices => ({
          ...voices,
          ...keyBy(
            action.payload.data.results.map(data => ({ data })),
            'data.id'
          ),
        }))
        .value()

    case 'VOICE/CREATE_VOICE_PROJECTS_FULFILLED': {
      analytics.track('Voice Actor Recording - Create', {
        ...action.payload.data,
        value: action.meta.price,
      })
      return i
        .chain(state)
        .assocIn(['byId', action.payload.data.id], action.payload.data)
        .value()
    }

    case 'VOICE/CREATE_VOICE_PROJECTS_REJECTED': {
      analytics.track('Voice Actor Recording - Create Error', action.payload.data)
      return state
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/features/Voices/Voices.reducer.ts